export enum PlatformSecurityPolicyCategory {
  SECURITY_POLICY = 'SECURITY_POLICY',
}

export enum PlatformSecurityPolicyConfigKey {
  PASSWORD_LENGTH = 'PASSWORD_LENGTH',
  PASSWORD_COMPLEXITY = 'PASSWORD_COMPLEXITY',
}

export enum PasswordComplexityPart {
  NUMBER = 'NUMBER',
  SYMBOL = 'SYMBOL',
  CASES = 'CASES',
}
